import React from "react";
import { getStripeLoadError, isCardProcessingNotSetUp, CARD_PAYMENTS_NOT_SET_UP } from "../../utils/stripeClient";

interface StripeBlockedAlertProps {
  /**
   * Say nothing when the club simply does not take cards. For screens that
   * explain that themselves where it matters (the registration wizard's
   * review step), so the first step does not open with it.
   */
  quietWhenNotSetUp?: boolean;
}

const StripeBlockedAlert: React.FC<StripeBlockedAlertProps> = ({ quietWhenNotSetUp = false }) => {
  // A club with no card processing is not a load failure: no "Reload Page"
  // (reloading cannot change it), and never the "taking longer than
  // expected" text (2026-10-10).
  if (isCardProcessingNotSetUp()) {
    if (quietWhenNotSetUp) return null;
    return (
      <div role="status" className="mb-4 rounded-md border border-amber-300 bg-amber-50 p-4 dark:border-amber-700 dark:bg-amber-900/30">
        <p className="text-sm font-medium text-amber-800 dark:text-amber-200">{CARD_PAYMENTS_NOT_SET_UP}</p>
      </div>
    );
  }
  const error = getStripeLoadError();
  if (!error) return null;

  return (
    <div className="mb-4 rounded-md border border-amber-300 bg-amber-50 p-4 dark:border-amber-700 dark:bg-amber-900/30">
      <div className="flex items-start gap-3">
        <svg
          className="mt-0.5 h-5 w-5 flex-shrink-0 text-amber-600 dark:text-amber-400"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.168 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 6a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 6zm0 9a1 1 0 100-2 1 1 0 000 2z"
            clipRule="evenodd"
          />
        </svg>
        <div className="flex-1">
          <p className="text-sm font-medium text-amber-800 dark:text-amber-200">
            {error}
          </p>
          <button
            onClick={() => window.location.reload()}
            className="mt-2 text-sm font-medium text-amber-700 underline hover:text-amber-900 dark:text-amber-300 dark:hover:text-amber-100"
          >
            Reload Page
          </button>
        </div>
      </div>
    </div>
  );
};

export default StripeBlockedAlert;
